import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Button, Modal } from '../../components';
import css from './ConfirmModal.module.css';
import {ReactComponent as CheckIcon} from './CheckIcon.svg'

const ConfirmModal = props => {
    const {
        onManageDisableScrolling,
        setIsConfirmModalOpen,
        isConfirmModalOpen
    } = props;


    return (
        <Modal
            id="ConfirmModal"
            containerClassName={css.ConfirmModal}
            isOpen={isConfirmModalOpen}
            onClose={() => { setIsConfirmModalOpen(false) }}
            hideCloseBtn={true}
            usePortal
            onManageDisableScrolling={onManageDisableScrolling}
        >
            <div className={css.content}>
                <h3 className={css.title}>
                    <FormattedMessage id="ConfirmModal.heading" />
                </h3>
                <div className={css.checkIcon}>
                    <CheckIcon />
                </div>
                <p className={css.infoText}>
                    <FormattedMessage id="ConfirmModal.infoText" />
                </p>
                <Button
                    className={css.closeButton}
                    onClick={() => setIsConfirmModalOpen(false)}
                >
                    <FormattedMessage id="ConfirmModal.closeButton" />
                </Button>
            </div>


        </Modal>
    );
};

export default ConfirmModal;